import React from 'react';
import { AccountStore, Component, LocationStore, AuthWrapper, FormActions } from '../../../client';
import { slugger } from '../../../common';
import MobilePreviewer from '../MobilePreviewer';
import MoveableMobilePreviewer from '../MoveableMobilePreviewer';
import config from '../../../core/common';

class FormPreviewer extends Component {
   static defaultProps = {
      noForm: null,
      isMoveable: false,
      x: 0,
      y: 0
   };

   constructor(props) {
      super(props);

      this.state = { token: null, version: -1 };

      this.listenables = [FormActions];
      this.stores = [LocationStore, AccountStore];
      this.storeKeys = ['locations', 'tid'];
   }

   async componentDidMount() {
      try {
         const token = await AuthWrapper.getTokenAsync();
         this.setState({ token });
      } catch (error) {
         // Handle any errors that occurred during the fetch
         console.error('Error:', error);
      }
   }

   onSetupFormPreviewCompleted(response) {
      var { version } = response.data.content.form;
      this.setState({ version });
   }

   render() {
      const { locations, tid, token, version } = this.state;
      const { noForm, isMoveable, x, y } = this.props;

      if (!locations || locations.length == 0 || noForm == null || token == null) {
         return <></>;
      }

      var slug = slugger.encode({ no: noForm, tid });

      const noLocation = locations[0].no;
      const key = `preview-${noForm}-${version}`;

      const uri = `${config.mobileWebsite}/preview/${slug}?no=${noLocation}&version=${version}&token=${token}`;

      return (
         <div className='FormPreviewer'>
            {!isMoveable && <MobilePreviewer id={key} uri={uri} />}
            {isMoveable && <MoveableMobilePreviewer id={key} uri={uri} x={x} y={y} />}
         </div>
      );
   }
}

export default FormPreviewer;
